import type { AreaTableView, AreaView } from '../../../../../services/areas/areas.service';
import type { MergeMode, TransferMode } from '../../../hooks/usePosOrdersDomain';

const DIGITS_ONLY = /^\d+$/;

// Summary: Resolves a typed table number to an active table across all given areas.
// Details: exact name wins; else a unique digits-only name compared as an integer ("07" = "7").
export function findTableByNumber(areas: AreaView[], input: string): AreaTableView | null {
  const wanted = input.trim();
  if (!wanted) {
    return null;
  }
  const tables = areas
    .filter((area) => area.isActive)
    .flatMap((area) => area.tables)
    .filter((table) => table.isActive);
  const exact = tables.find((table) => table.number.trim() === wanted);
  if (exact || !DIGITS_ONLY.test(wanted)) {
    return exact ?? null;
  }
  const numeric = tables.filter((table) => {
    const name = table.number.trim();
    return DIGITS_ONLY.test(name) && Number(name) === Number(wanted);
  });
  return numeric.length === 1 ? numeric[0] : null;
}

export function isTablePickActive(state: {
  transferStep: TransferMode['step'];
  mergeStep: MergeMode['step'];
  restorePending: boolean;
  setMinimum: boolean;
  splitMergeOrderPk: number | null;
}): boolean {
  return state.transferStep === 'pick-table' || state.mergeStep === 'pick-tables' ||
    state.restorePending || state.setMinimum || state.splitMergeOrderPk !== null;
}
